export const APP_NAME: string = "Venesia Store";
export const CAPATCHA_SITE_KEY: string = "";
export const CAPATCHA_SECRET_KEY: string = "";
export const FCM_vapidKey =
  "BPJzrNyOQDNiG8XLrqQZOlG3zEK9snNMsjxgRJaVTcViCoY087kwZ9YyDaZIH6L2Tj6tnyWra33NlaPysN2f2zA";

export const sadad_test_props = {
  phone_number: "0913632323",
  birth_year: "1998",
  amount: "50",
  payment_method_id: 3,
  code: "111111",
  invoice_no: 10,
};
